import { type OrderPaymentStatus } from '@sg/graphql-schema';

// ─────────────────────────────────────────────────────────────────────────────

export type PaymentStatePollingContext = Readonly<{
  orderId: string | undefined;
  paymentState: PaymentState;
  pollingConfiguration: PollingConfiguration;
}>;

export const initialContext: PaymentStatePollingContext = {
  orderId: undefined,
  paymentState: {
    paymentIntentId: undefined,
    paymentStateExpiration: undefined,
    paymentStateStatus: undefined,
    paymentStateError: undefined,
  },
  pollingConfiguration: {
    paymentStatePollingInterval: 0,
    paymentStateDelayedTolerance: 0,
    paymentStateExpirationTolerance: 0,
  },
};

export type PaymentState = {
  paymentIntentId: string | undefined;
  paymentStateExpiration: number | undefined;
  paymentStateStatus: OrderPaymentStatus | undefined;
  paymentStateError: string | undefined | null;
};

export type PollingConfiguration = {
  paymentStatePollingInterval: number;
  paymentStateDelayedTolerance: number;
  paymentStateExpirationTolerance: number;
};
